import React from "react";
import { Fragment } from "react";
import Navbar from "./components/navbar";
import { Main } from "./elements";

const Layout = ({ children }) => (
  <Fragment>
    <Navbar />
    <Main>{children}</Main>
  </Fragment>
);

export default Layout;
